/**
 * Success copy after saving pension preferences.
 * @param {{ factorChanged: boolean, paydayChanged: boolean, senderStatus?: string|null }} params
 * @returns {string}
 */
export const preferencesSaveMessage = ({
  factorChanged,
  paydayChanged,
  senderStatus = null,
}) => {
  if (factorChanged && paydayChanged) {
    if (senderStatus === 'frozen_paid') {
      return 'Guardamos el día de pago y el factor. Como este mes ya está pagado, el monto nuevo se verá el próximo mes. Los recordatorios usarán el día nuevo desde ahora.'
    }
    if (senderStatus === 'sender_failed') {
      return 'Guardamos tu configuración. El monto se actualizará cuando entres al panel. Los recordatorios usarán el día nuevo desde ahora.'
    }
    return 'Listo. El monto de este mes ya usa el factor nuevo y tus recordatorios usarán este día de pago.'
  }

  if (paydayChanged && !factorChanged) {
    return 'Listo. Tus recordatorios usarán este día de pago desde ahora.'
  }

  if (senderStatus === 'frozen_paid') {
    return 'Guardamos el factor. Como este mes ya está pagado, el monto nuevo se verá el próximo mes.'
  }

  if (senderStatus === 'sender_failed') {
    return 'Guardamos tu configuración. El monto se actualizará cuando entres al panel.'
  }

  if (senderStatus === 'updated' || senderStatus === 'ok') {
    return 'Listo. El monto de este mes ya usa el factor nuevo.'
  }

  return 'Configuración guardada.'
}
